import { render, staticRenderFns } from "./ActivationsBrandAsset.vue?vue&type=template&id=6d68eb89&"
import script from "./ActivationsBrandAsset.vue?vue&type=script&lang=js&"
export * from "./ActivationsBrandAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports